import { render, staticRenderFns } from "./comments-section.vue?vue&type=template&id=4219485b"
import script from "./comments-section.vue?vue&type=script&lang=js"
export * from "./comments-section.vue?vue&type=script&lang=js"
import style0 from "./comments-section.vue?vue&type=style&index=0&id=4219485b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports